import React from 'react';
import { Image } from 'semantic-ui-react';
import { getFile } from '../../../utils/api';

const CameraCard = ({ fileId: photo }) => (
  <Image src={getFile({ photo })} className="photo" />
);

export default CameraCard;
